import { Component, OnInit, OnChanges } from '@angular/core';
import { ParamUrlService } from '@service/paramurl.service';
import { Router } from '@angular/router';
import { LayoutService } from '../../layout/service/app.layout.service';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { truncString } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'dashlastrequest',
    templateUrl: 'dashlastrequest.component.html',
    styleUrls: ['dashlastrequest.component.scss'],
})
export class DashLastRequestComponent implements OnInit, OnChanges {
    public fr: any;
    public error = false;
    public listColumns: any[];
    public resultDisplay: any[];
    public isDesktop: boolean = false;
    public rowGroupMetadata: any;
    private titleReq: any[];

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private router: Router,
        private paramUrlService: ParamUrlService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.isDesktop = this.main.isDesktop();
        this.resultDisplay = new Array();
        this.titleReq = new Array();
    }

    public ngOnInit() {
        this.listColumns = this.getlistColumns();
        this.titleReq.push(this.translate.instant('Last_Quer_Idx'));
        this.titleReq.push(this.translate.instant('Last_Quer_Wds'));
        this.titleReq.push(this.translate.instant('Last_Quer_Brs'));
        this.getRequests();
    }

    public ngOnChanges() {}

    private async getRequests() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getlastrequests', ''));
            this.addData(wRes.data.data);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private addData(aData) {
        let wParamRequest: any;
        aData.forEach((item, index) => {   
            wParamRequest = JSON.parse(item.paramrequest);
            this.resultDisplay.push({
                id: item.id,
                login: item.login,
                dateaction: item.dateaction,
                id_request: item.id_request,
                id_result: item.id_result,
                paramrequest: wParamRequest,
                label: this.getLabel(item, wParamRequest),
                requesttype: item.requesttype,
                requestTypLab: this.getRequestTypLab(item.requesttype)
            });
        });
    }

    private getRequestTypLab(aType) {
        return this.titleReq[aType];
    }

    private getLabel(aItem, aParamRequest) {
        let wWord = '';
        switch (aItem.requesttype) {
            // index
            case 0 : return aItem.label;
            // wds
            case 1 :
                {
                    aParamRequest.SearchList.map(item => {
                        wWord = wWord + item.Search.Value + ', ';
                    });
                    if (aParamRequest.Root !== '') {
                        wWord = wWord + '(' + aParamRequest.Root + '\\' + aParamRequest.Path + '), ';
                    }
                    return truncString(wWord, 2);
                }
            // browse
            case 2 : return aParamRequest.Root + '\\' + aParamRequest.Path;
        }
    }

    public onRowSelect(event) {
        this.paramUrlService.clear();
        switch (event.data.requesttype) {
            // index
            case 0 : {
                this.paramUrlService.requestName = event.data.label;
                this.paramUrlService.isReqSys = false;
                this.paramUrlService.requestParamToUse = {
                    paramrequest: event.data.paramrequest,
                    idrequest: event.data.id_request,
                    idresult: event.data.id_result
                };
                this.router.navigate(['/page-request-list']);
                break;
            }
            // wds
            case 1 : {
                this.paramUrlService.fulltxt = true;
                this.paramUrlService.root = event.data.paramrequest.Root;
                if (event.data.paramrequest.Path !== '') {
                    this.paramUrlService.path = '\\' + event.data.paramrequest.Path;
                }
                if (event.data.paramrequest.SearchList[0] !== undefined) {
                    this.paramUrlService.text1 = event.data.paramrequest.SearchList[0].Search.Value;
                    this.paramUrlService.wordcond0 = event.data.paramrequest.SearchList[0].Search.Operator;
                }
                if (event.data.paramrequest.SearchList[1] !== undefined) {
                    this.paramUrlService.text2 = event.data.paramrequest.SearchList[1].Search.Value;
                    this.paramUrlService.wordcond1 = event.data.paramrequest.SearchList[1].Search.Operator;
                }
                if (event.data.paramrequest.SearchList[2] !== undefined) {
                    this.paramUrlService.text3 = event.data.paramrequest.SearchList[2].Search.Value;
                    this.paramUrlService.wordcond2 = event.data.paramrequest.SearchList[2].Search.Operator;
                }
                if (event.data.paramrequest.SearchList[4] !== undefined) {
                    this.paramUrlService.text4 = event.data.paramrequest.SearchList[3].Search.Value;
                }                                
                if (event.data.paramrequest.BeginDate !== undefined) {
                    this.paramUrlService.datebegin = event.data.paramrequest.BeginDate;
                }
                if (event.data.paramrequest.EndDate !== undefined) {
                    this.paramUrlService.dateend = event.data.paramrequest.EndDate;
                }
                this.router.navigate(['/fulltextsearch']);
                break;
            }
            // browse
            case 2 : {
                this.paramUrlService.tree = true;
                this.paramUrlService.root = event.data.paramrequest.Root;
                this.paramUrlService.path = '\\' + event.data.paramrequest.Path;
                this.paramUrlService.restricted = false;
                this.paramUrlService.fromDash = true;
                this.router.navigate(['/page-tree-search']);
                break;
            }
        }
    }

    private getlistColumns() {
        let wItem: any;
        let wColList = new Array();
        wItem = { header: this.translate.instant('Name'), field: 'label', type: 'String' };
        wColList.push(wItem);
        wItem = { header: this.translate.instant('Date'), field: 'dateaction', type: 'Date' };
        wColList.push(wItem);        
        return wColList;
    }
}
